"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescheduleModuleScreen = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var __1 = require("..");
var typeography_common_1 = require("../typeography/typeography.common");
var il_manage_student_overdue_1 = require("../il-manage-student-overdue/il-manage-student-overdue");
function RescheduleModuleScreen(_a) {
    var averageAssignmentsPerDay = _a.averageAssignmentsPerDay, className = _a.className, courses = _a.courses, dateEndYear = _a.dateEndYear, dateStartYear = _a.dateStartYear, defaultFormValues = _a.defaultFormValues, headerLeftComponent = _a.headerLeftComponent, headerRightComponent = _a.headerRightComponent, onSelectCourse = _a.onSelectCourse, onSelectStudent = _a.onSelectStudent, onSubmit = _a.onSubmit, selectedCourse = _a.selectedCourse, selectedStudent = _a.selectedStudent, students = _a.students, sx = _a.sx, _b = _a.title, title = _b === void 0 ? 'Reschedule Work' : _b, showSuccessMessage = _a.showSuccessMessage, _c = _a.successMessage, successMessage = _c === void 0 ? react_1.default.createElement(il_manage_student_overdue_1.SubmittedMessage, null) : _c;
    return (react_1.default.createElement(material_1.Box, { className: 'il-reschedule-module ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', backgroundColor: 'background.default', maxWidth: 'lg', borderRadius: '0.5rem' }, sx) },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                py: '1rem',
            } },
            react_1.default.createElement(material_1.Box, null, headerLeftComponent),
            react_1.default.createElement(typeography_common_1.ILH3, null, title),
            react_1.default.createElement(material_1.Box, null, headerRightComponent)),
        react_1.default.createElement(material_1.Divider, null),
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                flex: '1 1 0',
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    width: 0.2,
                    backgroundColor: 'background.default',
                    p: '1rem',
                    pb: 0,
                    boxSizing: 'content-box',
                } },
                react_1.default.createElement(__1.ILStudentList, { students: students, onSelectStudent: onSelectStudent, selected: selectedStudent })),
            react_1.default.createElement(material_1.Box, { sx: {
                    width: 0.4,
                    backgroundColor: 'background.paper',
                    pt: '1rem',
                    pb: '1rem',
                } },
                react_1.default.createElement(__1.WithSelectionExample, { showRightIndicator: true, title: "Active Courses", courses: courses, selectedCourse: selectedCourse, onClick: onSelectCourse, sx: {
                        pl: '2rem',
                        '& *': {
                            boxSizing: 'content-box',
                        },
                    } })),
            react_1.default.createElement(material_1.Box, { sx: __assign({ width: 0.4, p: '1rem', pl: '2rem', pb: 0, boxSizing: 'content-box' }, (selectedCourse
                    ? {
                        backgroundColor: 'background.default',
                    }
                    : {
                        display: 'flex',
                        backgroundColor: 'background.paper',
                        justifyContent: 'center',
                        alignItems: 'center',
                    })) }, showSuccessMessage ? (react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                } }, successMessage)) : (react_1.default.createElement(react_1.default.Fragment, null,
                !selectedCourse && (react_1.default.createElement(typeography_common_1.ILBody1, { sx: {
                        color: 'text.secondary',
                        textAlign: 'center',
                        px: { xs: '1rem', sm: '2rem', md: '3rem', lg: '3rem', xl: '3rem' },
                    } }, "Select a course to make adjustments to its schedule")),
                !!selectedCourse && (react_1.default.createElement(__1.RescheduleActivityForm, { startedDate: selectedCourse.startDate, activityDescription: selectedCourse.assignmentName, averageAssignmentsPerDay: averageAssignmentsPerDay, dateStartYear: dateStartYear, dateEndYear: dateEndYear, defaultFormValues: defaultFormValues, onSubmit: onSubmit, showModalHeader: true }))))))));
}
exports.RescheduleModuleScreen = RescheduleModuleScreen;
